import React from 'react'

function searchProducts() {
  return (
    <div>searchProducts</div>
  )
}

export default searchProducts